import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, postData, updateData, deleteData } from '../../../apiService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
// import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Select from 'react-select';
import CancelIcon from '@material-ui/icons/Cancel';

const ItemDetail = () => {
    const { isAuthenticated, companyId, permissions, logout, token, userId } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout, userId]);

    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    const { id } = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [formData, setFormData] = useState({
        name: '',
        gstRate: '',
        isSubmit: false,
    });

    //unitmaster

    const [selectedProduct, setSelectedProduct] = useState("");
    const [unitOptions, setUnitOptions] = useState([]);
    const [selectedunitType, setSelectedUnitType] = useState("");

    const fetchUnit = async () => {
        try {
            const response = await fetchData('UnitApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.name
                }));
                setUnitOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleUnitChange = (selectedOption) => {
        setSelectedUnitType(selectedOption);
    };

    useEffect(() => {
        fetchUnit();
    }, []);


    const [newRecordData, setNewRecordData] = useState({
        CategoryId: id,
        CompanyId: companyId,
        Name: '',
        CommodityCode: '',
        OpeningstockinQTY: '0',
        OpeningstockinPackets: '0',
        PurchaseRate: '0',
        SaleRate: '0',
        PurchaseRateinPkt: '0',
        SaleRateinpkt: '0',
        MRP: '0',
        Noofpktinacase: '0',
        HSNCode: '', // new feilds
        CGSTRate: '0',
        SGSTRate: '0',

    });

    const [updatedData, setUpdateData] = useState({
        Name: '',
        CommodityCode: '',
        OpeningstockinQTY: '',
        OpeningstockinPackets: '',
        PurchaseRate: '',
        SaleRate: '',
        PurchaseRateinPkt: '',
        SaleRateinpkt: '',
        MRP: '',
        Noofpktinacase: '',
        HSNCode: '', // new feilds
        CGSTRate: '',
        SGSTRate: '',
    });



    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    useEffect(() => {
        fetchData('CategoryApi', `/CategoryDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Category Details:', error);
            });

        fetchItemData();
    }, [id]);

    const fetchItemData = async () => {
        try {
            const response = await fetchData('ItemApi', `/${id}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Item', error);
        }
    };

    const openDetailModal = async (item) => {
        try {
            const response = await fetchData('ItemApi', `/ItemDetails/${item.Id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };



    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNewRecordData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    //Item Creation Section
    const [isLoading, setIsLoading] = useState(false);

    const addRecord = async () => {
        newRecordData.CategoryId = id;
        newRecordData.CompanyId = companyId;
        newRecordData.UnitId = selectedunitType.value;

        if (!newRecordData.Name) {
            setErrorMessage('Name is required ! Please fill all required fields.');
            setIsLoading(false);
            return;
        }
        if (!newRecordData.CommodityCode) {
            setErrorMessage('CommodityCode is required ! Please fill all required fields.');
            setIsLoading(false);
            return;
        }

        if (!newRecordData.HSNCode) {
            setErrorMessage('HSNCode is required ! Please fill all required fields.');
            setIsLoading(false);
            return;
        }

        if (!newRecordData.selectedunitType) {
            setErrorMessage('Unit is required ! Please fill all required fields.');
            setIsLoading(false);
            return;
        }


        try {
            await postData('ItemApi', newRecordData, token);
            setNewRecordData({
                CategoryId: id,
                CompanyId: companyId,
                Name: '',
                CommodityCode: '',
                OpeningstockinQTY: '',
                OpeningstockinPackets: '',
                PurchaseRate: '',
                SaleRate: '',
                PurchaseRateinPkt: '',
                SaleRateinpkt: '',
                MRP: '',
                Noofpktinacase: '',
                HSNCode: '', // new feilds
                CGSTRate: '',
                SGSTRate: '',
                CreatedBy: userId,
                CreatedDate: new Date(),
            });

            fetchItemData();
            setIsModalOpen(false);
        } catch (error) {
            console.error('Item Create error:', error);
        }
    };

    //Item UpDate Section

    const updateRecord = async (event) => {
        event.preventDefault();
        updatedData.UnitId = selectedunitType.value;

        try {

            await updateData('ItemApi', `${updatedData.Id}`, updatedData, token);
            setUpdateData({
                CategoryId: id,
                CompanyId: companyId,
                Name: '',
                CommodityCode: '',
                OpeningstockinQTY: '',
                OpeningstockinPackets: '',
                PurchaseRate: '',
                SaleRate: '',
                PurchaseRateinPkt: '',
                SaleRateinpkt: '',
                MRP: '',
                Noofpktinacase: '',
                HSNCode: '', // new feilds
                CGSTRate: '',
                SGSTRate: '',
            });
            fetchItemData();
            setIsDetailModalOpen(false);
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };


    const handleDelete = async () => {
        try {
            await deleteData('CategoryApi', `${deleteItemId}`, token);
            fetchItemData();
            setDeleteItemId(null);
            setConfirmDialogOpen(false);
        } catch (error) {
            console.error('Error deleting record:', error);
        }
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '100%' }}>
            <div className="w-full mb-2 flex">
                <h6 className="productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder' }}> CATEGORY - DETAILS</h6>

                <Tooltip title="Exit">
                    <Link to="/ItemIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                        <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                            Exit <ExitToAppIcon />
                        </Button>
                    </Link>
                </Tooltip>
            </div>
            {/* {errorMessage && <p className="text-red-500">{errorMessage}</p>} */}
            {successMessage && <p className="text-green-500">{successMessage}</p>}

            <div className="w-full pl-4" style={{ width: '100%' }}>
                <div className="bg-teal-700 rounded-lg shadow-lg p-6">
                    <div className="w-full mb-5 flex">
                        <h3 className="text-lg font-semibold mb-4 linkcolor mr-2">{formData.name}</h3>
                        {/* <h4 className="text-lg font-semibold mb-4 linkcolor mr-2">- Sub Category</h4> */}
                        {hasCreateMasterPermission && (
                            <div className="ml-auto">
                                <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={toggleModal}>
                                    Add Record
                                </button>
                            </div>
                        )}


                        {isModalOpen && (
                            <div className="fixed inset-0 flex items-center justify-center z-10">
                                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1000px' }}>
                                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                                    <h6 className="text-center text-black font-bold" style={{ fontFamily: 'Times New Roman' }}>ITEM CREATE</h6>

                                    <div className="w-full mb-4 flex">
                                        <div className="w-1/2 mr-2" style={{ width: '80%' }}>
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                                Name
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                type="text"
                                                name="Name"
                                                placeholder="Enter Item name"
                                                value={newRecordData.Name}
                                                onChange={handleInputChange}

                                            />
                                        </div>
                                        <div className="w-1/4 mr-2">

                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                                Unit
                                            </label>
                                            <Select
                                                value={selectedunitType}
                                                onChange={handleUnitChange}
                                                options={unitOptions}
                                                placeholder="Select Unit"
                                                isSearchable
                                            />
                                        </div>
                                    </div>

                                    <div className="w-full mb-4 flex">
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                                Commodity Code
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center"
                                                type="text"
                                                name="CommodityCode"
                                                placeholder="Enter CommodityCode"
                                                value={newRecordData.CommodityCode}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MinimumStock">
                                                No of pkt (Case)
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Noofpktinacase"
                                                placeholder="No of pkt (Case)"
                                                value={newRecordData.Noofpktinacase}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                                HSNCode
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center"
                                                type="text"
                                                name="HSNCode"
                                                placeholder="Enter HSNCode"
                                                value={newRecordData.HSNCode}
                                                onChange={handleInputChange}
                                            />
                                        </div>


                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="GST">
                                                CGST %
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="CGSTRate"
                                                placeholder="Enter CGST"
                                                value={newRecordData.CGSTRate}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                SGST %
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="SGSTRate"
                                                placeholder="Enter SGSTRate"
                                                value={newRecordData.SGSTRate}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                MRP
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="MRP"
                                                placeholder="Enter MRP"
                                                value={newRecordData.MRP}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>


                                    <div className="w-full mb-4 flex">

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                Purchase Rate
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="PurchaseRate"
                                                placeholder="Enter PurchaseRate"
                                                value={newRecordData.PurchaseRate}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="OpeningStock">
                                                Sale Rate
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="SaleRate"
                                                placeholder="Enter SaleRate"
                                                value={newRecordData.SaleRate}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="TotalStock">
                                                Purchase Rate (PKT)
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="PurchaseRateinPkt"
                                                placeholder="Purchase Rate( Pkt )"
                                                value={newRecordData.PurchaseRateinPkt}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="CurrentStock">
                                                Sale Rate (PKT)
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="SaleRateinpkt"
                                                placeholder="Sale Rate( Pkt )"
                                                value={newRecordData.SaleRateinpkt}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Description">
                                                Opening Stock (QTY)
                                            </label>

                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="OpeningstockinQTY"
                                                placeholder="Opening Stock(QTY)"
                                                value={newRecordData.OpeningstockinQTY}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                Opening Stock (PKT)
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="OpeningstockinPackets"
                                                placeholder="Opening Stock(PKT)"
                                                value={newRecordData.OpeningstockinPackets}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                    </div>

                                    {/* end here */}
                                    <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                        {/* <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addRecord}>
                                            Add Record
                                        </button> */}
                                        <button onClick={addRecord} style={{ color: 'darkolivegreen', fontWeight: 'bolder', marginLeft: '2px' }} disabled={isLoading}>
                                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Add Record"} <CheckCircleIcon />
                                        </button>
                                        {/* <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModal}>
                                            Cancel
                                        </button> */}
                                        <button  onClick={toggleModal} style={{ color: 'red', fontWeight: 'bolder' , marginLeft:'10px' }}>
                                            Cancel <CancelIcon />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>

                    <div className='w-full mb-5 flex' style={{ maxHeight: '400px', overflowY: 'auto', width: '100%', marginTop: '-40px' }}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#f3f3f3' }}> {/* Set background color */}
                                    <TableRow>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'left', width: '240px' }}>Name</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', width: '80px' }}>HSN</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', width: '120px' }}>Commodity Code</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', width: '80px' }}>Unit</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', width: '100px' }}>Sale Rate</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', width: '100px' }}>Sale Rate (PKT)</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', width: '100px' }}>Purchase Rate</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', width: '40px' }}>CGST</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', width: '40px' }}>SGST</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', width: '40px' }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data && data.map(item => (
                                        <TableRow key={item.Id}>
                                            <TableCell className="customTableCell" sx={{ width: '240px', padding: '5px', textAlign: 'left' }}>{item.Name}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '80px', padding: '5px', textAlign: 'center' }}>{item.HSNCode}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '120px', padding: '5px', textAlign: 'center' }}>{item.CommodityCode}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '80px', padding: '5px', textAlign: 'center' }}>{item.unitname}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '100px', padding: '5px', textAlign: 'center' }}>{item.SaleRate}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '120px', padding: '5px', textAlign: 'center' }}>{item.SaleRateinpkt}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '120px', padding: '5px', textAlign: 'center' }}>{item.PurchaseRate}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '40px', padding: '5px', textAlign: 'center' }}>{item.CGSTRate}</TableCell>
                                            <TableCell className="customTableCell" sx={{ width: '40px', padding: '5px', textAlign: 'center' }}>{item.SGSTRate}</TableCell>
                                            <TableCell className="customTableCell" sx={{ padding: '5px', width: '150px', padding: '5px', textAlign: 'center' }}>

                                                <IconButton onClick={() => openDetailModal(item)}>
                                                    <ArrowForward style={{ color: 'darkgoldenrod', fontWeight: 'bold', height: '20px' }} />
                                                </IconButton>
                                                {hasDeleteMasterPermission && (
                                                    <IconButton onClick={() => openConfirmDialog(item.Id)}>
                                                        <DeleteIcon style={{ color: 'brown', fontWeight: 'bold', height: '20px' }} />
                                                    </IconButton>
                                                )}

                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>

                                {/* Delete confirmation dialog */}
                                <Dialog
                                    open={confirmDialogOpen}
                                    onClose={closeConfirmDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            Are you sure you want to delete this record?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <button onClick={closeConfirmDialog} className="cancelbutton">
                                            Cancel
                                        </button>
                                        <button onClick={handleDelete} className="confirmbutton">
                                            Confirm
                                        </button>
                                    </DialogActions>
                                </Dialog>
                            </Table>
                        </TableContainer>

                        {isDetailModalOpen && (
                            <div className="fixed inset-0 flex items-center justify-center z-10">
                                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1000px' }}>
                                    <h6 className="text-center text-black font-bold" style={{ fontFamily: 'Times New Roman' }}>ITEM EDIT</h6>
                                    <div className="w-full mb-4 flex">

                                        <div className="w-1/2 mr-2" style={{ width: '80%' }}>
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                                Name
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                type="text"
                                                name="Name"
                                                placeholder="Enter Item name"
                                                value={updatedData.Name}
                                                onChange={handleUpdateInputChange}

                                            />
                                        </div>
                                        <div className="w-1/4 mr-2">

                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                                Unit
                                            </label>

                                            <Select
                                                value={selectedunitType || (updatedData.unitname ? { value: updatedData.UnitId, label: updatedData.unitname } : '')}
                                                onChange={handleUnitChange}
                                                options={unitOptions}
                                                placeholder="Unit"
                                                isSearchable
                                            />
                                        </div>

                                    </div>

                                    <div className="w-full mb-4 flex">
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                                Commodity Code
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center"
                                                type="text"
                                                name="CommodityCode"
                                                placeholder="Enter CommodityCode"
                                                value={updatedData.CommodityCode}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MinimumStock">
                                                No of pkt (Case)
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="Noofpktinacase"
                                                placeholder="No of pkt (Case)"
                                                value={updatedData.Noofpktinacase}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                                HSNCode
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center"
                                                type="text"
                                                name="HSNCode"
                                                placeholder="Enter HSNCode"
                                                value={updatedData.HSNCode}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>


                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="GST">
                                                CGST %
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="CGSTRate"
                                                placeholder="Enter CGST"
                                                value={updatedData.CGSTRate}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                SGST %
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="SGSTRate"
                                                placeholder="Enter SGSTRate"
                                                value={updatedData.SGSTRate}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                MRP
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="MRP"
                                                placeholder="Enter MRP"
                                                value={updatedData.MRP}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                    </div>


                                    <div className="w-full mb-4 flex">

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                Purchase Rate
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="PurchaseRate"
                                                placeholder="Enter PurchaseRate"
                                                value={updatedData.PurchaseRate}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="OpeningStock">
                                                Sale Rate
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="SaleRate"
                                                placeholder="Enter SaleRate"
                                                value={updatedData.SaleRate}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="TotalStock">
                                                Purchase Rate (PKT)
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="PurchaseRateinPkt"
                                                placeholder="Purchase Rate( Pkt )"
                                                value={updatedData.PurchaseRateinPkt}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="CurrentStock">
                                                Sale Rate (PKT)
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="SaleRateinpkt"
                                                placeholder="Sale Rate( Pkt )"
                                                value={updatedData.SaleRateinpkt}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>
                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="Description">
                                                Opening Stock (QTY)
                                            </label>

                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="OpeningstockinQTY"
                                                placeholder="Opening Stock(QTY)"
                                                value={updatedData.OpeningstockinQTY}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>

                                        <div className="w-1/10 mr-2">
                                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="MRP">
                                                Opening Stock (PKT)
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                type="text"
                                                name="OpeningstockinPackets"
                                                placeholder="Opening Stock(PKT)"
                                                value={updatedData.OpeningstockinPackets}
                                                onChange={handleUpdateInputChange}
                                            />
                                        </div>

                                    </div>
                                    {/* end here */}
                                    <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                        {hasEditMasterPermission && (
                                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={updateRecord}>
                                                Update Record
                                            </button>
                                        )}
                                        <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModalBranch}>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}


                    </div>
                </div>
            </div>
        </div>

    );
};

export default ItemDetail;
